import React, { Component } from 'react'
import { Trans } from '@lingui/react'

import HeaderBox from 'client/shared/boxes/header-box'
import DogPlaceholder from 'client/shared/blocks/dog-placeholder'
import FooterStoreButtons from 'client/shared/blocks/footer-store-buttons'
import { LayoutColumn } from 'client/shared/blocks/layout-column'
import { Heading } from 'client/shared/blocks/heading'
import Spacer from 'client/shared/blocks/spacer'

export default class SpecialOfferUnavailable extends Component {
  render(): JSX.Element {
    return (
      <>
        <HeaderBox />
        <LayoutColumn>
          <Spacer size="top-page" />
          <DogPlaceholder />
          <Spacer size={32} />
          <Heading kind="kazimir">
            <Trans id="subscription.three_months_unavailable_title" />
          </Heading>
          <div>
            <p>
              <Trans id="subscription.three_months_unavailable_region" />
            </p>
            <p>
              <Trans id="subscription.three_months_unavailable_vpn" />
            </p>
          </div>
          <Spacer size={32} />
          <p>
            <Trans id="errors.apps" />
          </p>
          <FooterStoreButtons kind="inline" />
          <Spacer size="bottom-page" />
        </LayoutColumn>
      </>
    )
  }
}
